// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1104":"7136cf1a","1274":"7136cf1a","2273":"1b4fc7b9","2441":"098ebd72","2764":"735747e2","5284":"53ccd231","7568":"dbcc3026","7666":"0cba5e4d","7923":"1732a733","9526":"0cba5e4d"}[chunkId] + ".chunk.css";
};